var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.open)?_c('div',{staticClass:"netstate",attrs:{"role":"dialog","aria-modal":"true","aria-label":_vm.title}},[_c('div',{staticClass:"nbody"},[_vm._t("default")],2),_c('div',{staticClass:"nfoot"},[_vm._t("foot")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }